import React, { Fragment } from 'react';

// === Components === //
import Container from '@components/common/Container';
import Paragraph from '@components/common/Paragraph';

// === Helpers === //
import get from 'lodash.get';
import * as utils from '@utils';

// === Styles === //
import styled from '@emotion/styled';
import { colors, dimensions } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { FieldLayoutBgEntityData } from '@content/types/page';

const BackgroundBoxWrapper = styled.div<BackgroundBoxWrapperProps>`
  background: ${(props) =>
    props.variant === 'blue' ? colors.text.patientHeader : colors.ui.hcpDark};
  padding: 25px 0;
  text-align: ${(props) => (props.centered ? 'center' : 'left')};
  max-width: ${(props) => (props.centered ? '1050px' : 'none')};
  margin: auto;

  p {
    margin: 0;
    font-size: ${dimensions.fontSize.lg_md}px;
  }

  .paragraph-wrapper {
    margin: 0;
  }
`;

const BackgroundBoxContent = styled(Paragraph)`
  ul {
    li {
      &::before {
        background-color: ${colors.white};
      }
    }
  }
`;

const BackgroundBoxTitle = styled.h3`
  text-transform: uppercase;
  color: ${colors.white};
  font-size: 18px;
  margin-bottom: 30px;
`;

interface BackgroundBoxProps {
  variant: Variant;
  text: FieldLayoutBgEntityData[];
  centered?: boolean;
}

interface BackgroundBoxWrapperProps {
  variant: Variant;
  centered: boolean;
}

const BackgroundBox = ({ text, variant, centered = false }: BackgroundBoxProps) => {
  return (
    <BackgroundBoxWrapper variant={variant} centered={centered}>
      <Container>
        <>
          {text.map((t, index) => {
            const item = get(t, 'entity', null);

            return (
              <Fragment key={index}>
                {item && item.entityBundle === 'content' && item.fieldLongText && (
                  <BackgroundBoxContent
                    color={colors.white}
                    variant={variant}
                    text={get(item, 'fieldLongText.value', '')}
                  />
                )}
                {item && item.entityBundle === 'title' && item.fieldTitle && (
                  <BackgroundBoxTitle>
                    {utils.SafeHtml(get(item, 'fieldTitle', ''))}
                  </BackgroundBoxTitle>
                )}
              </Fragment>
            );
          })}
        </>
      </Container>
    </BackgroundBoxWrapper>
  );
};

export default BackgroundBox;
